import { useObserver } from "mobx-react";
import { useNavigation } from "./NavigationProvider";

export function Navigator() {
  const navigation = useNavigation();

  return useObserver(() => {
    const { location } = navigation;
    return location ? location.render() : null;
  });
}
